import { FC } from 'react';

import { BrandAffinityLevel } from 'modules/domains/brandAffinity';
import { PieChartIcon } from 'ui/brandAffinityIndicator/PieChartIcon';

import { getScoreUIDataByLevel } from '../utils';
import { ColoredPieContainer } from './ScoreCard.styles';

export const createIconDimensions = (isCurrentScore: boolean, percent: number) => ({
  fullStroke: isCurrentScore ? 4 : 3,
  percentage: percent,
  pxWidth: isCurrentScore ? 32 : 16,
  thinStroke: isCurrentScore ? 4 : 3,
});

export interface BrandAffinityIconProps {
  isCurrentScore?: boolean;
  label: BrandAffinityLevel;
}
export const BrandAffinityIcon: FC<React.PropsWithChildren<BrandAffinityIconProps>> = ({
  isCurrentScore = false,
  label,
}) => {
  const { percent } = getScoreUIDataByLevel(label);
  return (
    <ColoredPieContainer
      style={{
        color: getScoreUIDataByLevel(label).color.text,
      }}
    >
      <PieChartIcon {...createIconDimensions(isCurrentScore, percent)} />
    </ColoredPieContainer>
  );
};
